import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { initLenis } from "@/lib/scroll";
import { CitekMark } from "@/components/Logo";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import { Stats, Services } from "@/components/site/Services";
import { Projects, About, Process } from "@/components/site/Work";
import Trust from "@/components/site/Trust";
import Rse from "@/components/site/Rse";
import { Contact, Footer } from "@/components/site/Contact";

function LoadingScreen() {
  return (
    <div className="min-h-screen bg-[#EBECE8] flex flex-col items-center justify-center gap-5" data-testid="loading-screen">
      <CitekMark size={54} className="animate-pulse" />
      <p className="font-tech text-xs uppercase tracking-[0.3em] text-zinc-500">CITEK — Chargement</p>
    </div>
  );
}

export default function Home() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    initLenis();
    api
      .get("/content")
      .then((r) => setContent(r.data))
      .catch(() => setContent(null));
  }, []);

  if (!content) return <LoadingScreen />;

  return (
    <div className="bg-[#EBECE8] min-h-screen" data-testid="home-page">
      <Nav />
      <main>
        <Hero hero={content.hero} marquee={content.marquee} />
        <Stats stats={content.stats} />
        <Services services={content.services} />
        <Projects projects={content.projects} />
        <About about={content.about} />
        <Trust trust={content.trust} />
        <Process process={content.process} />
        <Rse rse={content.rse} />
        <Contact contact={content.contact} />
      </main>
      <Footer footer={content.footer} />
    </div>
  );
}
